export default {
  title: {
    en: 'Error!',
  },
  text: {
    en: 'Never send a human to do a machine\'s job.',
  },
  tryAgain: {
    en: 'Try again',
  },
}
